<template lang="pug">
UniversalLink(
    :link="data.link"
    trackingEventType="ImageCard"
    :openNewWindow="data.linkTarget === 'NEW_WINDOW'"
    class="block relative"
    v-bind="backgroundImageAttrs"
)
    div(
        class="absolute inset-0 bg-[#000000]"
        :style="shadeStyle"
    )

    div(
        class="relative flex flex-col"
        :class="wrapperClasses"
    )
        div
            template(v-for="widget in data.widgets")
                slot(:data="widget")

        //- OLD - keep until migration
        div(v-if="data.text")
            template(v-for="textWidget in data.text")
                slot(:data="textWidget")
        //- OLD - keep until migration
        div(v-if="data.button")
            template(v-for="buttonWidget in data.button")
                slot(:data="buttonWidget")
</template>

<script>
import UniversalLink from '@/components/universalLink'
import { generateFlexAlignmentClass, backgroundImageMixin } from '../../helpers'

export default {
    name: 'ImageCardWidget',
    components: {
        UniversalLink,
    },
    mixins: [backgroundImageMixin],
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
        spaceLeft: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    computed: {
        wrapperClasses() {
            return [this.generateSizeClass(), generateFlexAlignmentClass(this.data.position)]
        },
        shadeStyle() {
            const style = {}

            let opacity = null

            // Backwards compatability
            if (this.data.shadeOpacity && this.data.shadeOpacity !== '')
                opacity = parseInt(this.data.shadeOpacity)

            if (this.data.mobileShadeOpacity && this.data.mobileShadeOpacity !== '')
                opacity = parseInt(this.data.mobileShadeOpacity)

            if (
                this.data.tabletShadeOpacity &&
                this.data.tabletShadeOpacity !== '' &&
                !this.$device.isMobile
            )
                opacity = parseInt(this.data.tabletShadeOpacity)

            if (
                this.data.desktopShadeOpacity &&
                this.data.desktopShadeOpacity !== '' &&
                this.$device.isDesktop
            )
                opacity = parseInt(this.data.desktopShadeOpacity)

            if (!isNaN(opacity)) {
                style.opacity = Math.min(Math.max(opacity * 0.01, 0), 1)
            }

            return style
        },
    },
    methods: {
        generateSizeClass() {
            switch (this.data.size) {
                case 'SMALL':
                    return 'min-h-[280px] lg:min-h-[420px]'

                case 'MEDIUM':
                    return 'min-h-[350px] lg:min-h-[460px]'

                case 'LARGE':
                    return 'min-h-[400px] lg:min-h-[500px]'
            }
        },
    },
}
</script>
